import { createContextProvider, createDataContext } from '../utils'
import type { Nullable } from '../../types/common.ts';
import type { iAm } from '../../../api/index.ts';
import type { GameSession } from '../../types/game-session.ts';

export const LoaderContext = createDataContext<boolean>()
export const LoaderContextProvider = createContextProvider<boolean>(LoaderContext)
LoaderContext.displayName = 'LoaderContext'

export const AuthContext = createDataContext<Nullable<iAm>>()
export const AuthContextProvider = createContextProvider<Nullable<iAm>>(AuthContext)
AuthContext.displayName = 'AuthContext'

export const GameSessionContext = createDataContext<Partial<GameSession>>()
export const GameSessionContextProvider = createContextProvider<Partial<GameSession>>(GameSessionContext)
GameSessionContext.displayName = 'GameSessionContext'